/**
 * "Madrasa Office": what a clerk needs to run the madrasa's day-to-day office: register and enroll
 * students, collect fees, and read reports. It deliberately leaves out anything destructive or
 * that changes what fees ARE: no deleting, no fee setup changes, no voiding receipts, no
 * changing madrasa settings. Add those separately for a manager.
 * Names must match Fakhri-api PERMISSIONS (checked by the tests below).
 */
export const MADRASA_OFFICE_PRESET: readonly string[] = [
  "madrasaSettings.view",
  "madrasaClasses.view",
  "madrasaClasses.create",
  "madrasaClasses.edit",
  "madrasaStudents.view",
  "madrasaStudents.create",
  "madrasaStudents.edit",
  "madrasaEnrollments.view",
  "madrasaEnrollments.create",
  "madrasaEnrollments.edit",
  "madrasaFeeSetup.view",
  "madrasaFees.view",
  "madrasaFees.create",
];

/** Adds the preset to what is already ticked, keeping everything else and never duplicating. */
export function applyPreset(
  current: readonly string[] | null | undefined,
  preset: readonly string[] = MADRASA_OFFICE_PRESET
): { next: string[]; added: string[] } {
  const have = new Set(current ?? []);
  const added = preset.filter((p) => !have.has(p));
  return { next: [...(current ?? []), ...added], added };
}
